// extracted by mini-css-extract-plugin
export var almaLogoContainer = "learnMore-module--almaLogoContainer--a78b0";
export var almagreen = "learnMore-module--almagreen--33bf1";
export var beige = "learnMore-module--beige--b853c";
export var blue = "learnMore-module--blue--dae07";
export var contentGridWrapper = "learnMore-module--contentGridWrapper--8990a";
export var copyContainer = "learnMore-module--copyContainer--c72a9";
export var ctaContainer = "learnMore-module--ctaContainer--b0a30";
export var darkteal = "learnMore-module--darkteal--1494a";
export var imageContainer = "learnMore-module--imageContainer--3f71a";
export var matcha = "learnMore-module--matcha--82c79";
export var moduleContainer = "learnMore-module--moduleContainer--76fba";
export var rose = "learnMore-module--rose--fd37b";
export var rust = "learnMore-module--rust--6e529";
export var subheaderText = "learnMore-module--subheaderText--9e912";
export var teal = "learnMore-module--teal--806f6";